interface CompletionIconProps {
  size?: number;
}

export function CompletionIcon({ size = 75 }: CompletionIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 75 75"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M55.5893 1.5H6.24259C3.84746 1.5 1.875 3.43738 1.875 5.86791V69.1321C1.875 71.5274 3.81224 73.5 6.24259 73.5H51.257C53.6521 73.5 55.6246 71.5626 55.6246 69.1321V36.8307M24.664 50.9207L16.4219 59.1634L12.1248 54.8659M23.0085 48.6663C21.2122 47.1869 18.9227 46.3063 16.4219 46.3063C10.7159 46.3063 6.06648 50.956 6.06648 56.6624C6.06648 62.3689 10.7159 67.0186 16.4219 67.0186C22.128 67.0186 26.7773 62.3689 26.7773 56.6624C26.7773 55.3591 26.5308 54.1262 26.1081 52.9638M32.272 37.8523L38.753 44.3337L71.8622 11.2221C74.046 9.03816 74.046 5.55088 71.8622 3.36693C69.6784 1.18297 66.1913 1.18297 64.0075 3.36693L29.0668 38.3102L27.6227 47.6096L36.9214 46.1654M12.1248 12.8777H34.8785M12.1248 23.0225H24.664"
        stroke="#090C33"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.5299 50.9986L16.2827 59.2458L11.9829 54.946M22.8734 48.743C21.076 47.2627 18.7851 46.3816 16.2827 46.3816C10.5732 46.3816 5.9209 51.0338 5.9209 56.7434C5.9209 62.453 10.5732 67.1053 16.2827 67.1053C21.9923 67.1053 26.6446 62.453 26.6446 56.7434C26.6446 55.4394 26.3979 54.2058 25.9749 53.0428"
        stroke="#1FCC8C"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
